import * as CookieConsent from "vanilla-cookieconsent";
import { CONSENT_SERVICES } from "./consentServices";

function buildCategories(iframeManager) {
  const categories = {
    necessary: {
      enabled: true,
      readOnly: true,
    },
  };
  for (const [service, { category, label }] of Object.entries(
    CONSENT_SERVICES,
  )) {
    if (!categories[category]) {
      categories[category] = { enabled: false, readOnly: false, services: {} };
    }
    categories[category].services[service] = {
      label,
      onAccept: () => iframeManager.acceptService(service),
      onReject: () => iframeManager.rejectService(service),
    };
  }
  return categories;
}

export function initCookieConsent(iframeManager, translations, lang) {
  const categories = buildCategories(iframeManager);

  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "bottom left",
      },
      preferencesModal: {
        layout: "box",
      },
    },

    categories,

    language: {
      default: lang,
      autoDetect: "document",
      translations: {
        [lang]: {
          consentModal: translations.consentModal,
          preferencesModal: {
            title: translations.preferencesModal.title,
            acceptAllBtn: translations.preferencesModal.acceptAllBtn,
            acceptNecessaryBtn: translations.preferencesModal.acceptNecessaryBtn,
            savePreferencesBtn: translations.preferencesModal.savePreferencesBtn,
            sections: Object.keys(categories).map((category) => ({
              title: translations.preferencesModal.sections[category].title,
              description:
                translations.preferencesModal.sections[category].description,
              linkedCategory: category,
            })),
          },
        },
      },
    },
  });
}
